<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de Productos</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Crear producto</strong>
            </h5>
          </div>
        </div>
        <b-form @submit="save" @reset="onReset">
          <div class="row">
            <div class="col-md-4 col-lg-3">
              <b-form-group id="input-group-1" label="Nombre:" label-for="input-2" description="Ejemplo: Botella de agua">
                <b-form-input id="input-1" v-model="form.name" required placeholder="Ingrese el nombre del producto"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4 col-lg-3">
              <b-form-group label="Descripción:" label-for="textarea">
              <b-form-textarea
                id="textarea"
                v-model="form.description"
                placeholder="Descripción"
                class="form-control"
                maxlength="255"
              ></b-form-textarea>
              <small :class="{'text-muted': characterEnabled > 0, 'text-danger': characterEnabled === 0 }">{{ characterEnabled }} caracteres restantes</small>
            </b-form-group>
            </div>
            <div class="col-md-4 col-lg-3 col-xl-2">
              <b-form-group id="input-group-1-edit" label="Código de barras:" label-for="input-code-bar" description="Ejemplo: 8014572365842">
                <div class="d-flex flex-row align-items-center">
                  <b-form-input id="input-code-bar" v-model="form.barCode" placeholder="Ingrese el codigo de barras"></b-form-input>
                <i class="fa fa-info-circle ml-1" v-b-tooltip title="Ingresa un código alfanumérico o numérico con una longitud máxima de 16 caracteres."/>
                </div>
                <small v-show="form.barCode.length > 16" class="text-danger">Máximo 16 caracteres</small>
              </b-form-group>
            </div>
            <div class="col-md-4 col-lg-3 col-xl-2">
              <b-form-group id="input-group-2" label="Precio:" label-for="input-2" description="Precio del producto.">
                <money v-model="form.cost" v-bind="money" class="form-control" required></money>
              </b-form-group>
            </div>
            <div class="col-md-4 col-lg-3 col-xl-2">
              <b-form-group id="input-group-3" label="Activo:" label-for="input-3" description="Estado del producto.">
                <b-form-checkbox-group
                  id="checkbox-group-1"
                  v-model="form.activeArray"
                  :options="options"
                  name="flavour-1"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
          <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-form>
        <a-divider />
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de productos</strong>
            </h5>
            <h5 class="mb-4" style="padding-top: 0px;padding-bottom: 0px;">
              <b-row align-v="center">
                <b-col sm="12" lg="3" class="p-3">
                  <b-input id="input-product" v-model="searchProduct" placeholder="Ingrese el nombre del producto"></b-input>
                </b-col>
                <b-col sm="12" lg="6" class="p-3">
                  <b-button variant="primary" class="my-3 mx-2" @click="cleanProductSearch()">Limpiar</b-button>
                </b-col>
                <b-col sm="12" lg="3" class="mr-auto p-3">
                  <b-button squared variant="outline-success" id="test" class="btn-rounded mr-2 mb-2" v-on:click="downloadProductsReport()">
                    <i class="fe fe-download mr-1"></i>
                    Descargar reporte de productos
                  </b-button>
                </b-col>
              </b-row>
            </h5>
          </div>
        </div>
        <b-row>
          <b-col>
            <b-table v-if="data.length > 0" striped hover :fields="columns" :items="data" head-variant="light" responsive>
              <template #cell(active)="product">
                <i v-show="product.item.active" class="fa fa-check-circle text-success" style="font-size: 1.5rem;" />
                <i v-show="!product.item.active" class="fa fa-close  text-danger" style="font-size: 1.5rem;" />
              </template>
              <template #cell(order)="product">
                <input class="form-control" type="number"
                v-model="product.item.order"
                v-on:change="checkValue(product.item)"
                placeholder="#"
                :max="data.length" :min="1"
                style="width: 4em;display: inherit;">
              </template>
              <template #cell(action)="product">
                <button type="button" @click="openProduct(product.item)" class="btn btn-light mr-2" data-toggle="tooltip" data-placement="top" title="Ver producto">
                  <i class="fa fa-eye text-blue fa-lg" />
                </button>
                <button type="button" v-on:click="openModal(product.item)" class="btn btn-light mr-2" data-toggle="tooltip" data-placement="top" title="Editar">
                  <i class="fa fa-pencil text-blue" />
                </button>
                <button type="button" v-on:click="deleteProduct(product.item)" class="btn btn-light mr-2" data-toggle="tooltip" data-placement="top" title="Eliminar">
                  <i class="fa fa-close text-red" />
                </button>
                <button type="button" v-on:click="openModalUploadImage(product.item)" class="btn btn-light mr-2" data-toggle="tooltip" data-placement="top" title="Subir imagen">
                  <i class="fa fa-upload text-blue" />
                </button>
                <button type="button" v-on:click="openModalTags(product.item)" class="btn btn-light mr-2" data-toggle="tooltip" data-placement="top" title="Administrar categoría">
                  <i class="fa fa-tags text-blue" />
                  <i class="fa fa-plus text-blue" />
                </button>
              </template>
            </b-table>
            <empty-table v-else/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-pagination
              v-model="pagination.page"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              @input="search()"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ pagination.rows }} resultados
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal id="edit-product" ref="modal" title="Editar producto" hide-footer>
      <b-form @submit="edit" ref="todoform">
        <div class="row">
          <b-col md="6">
            <b-form-group id="input-group-1-edit" label="Nombre:" label-for="input-2" description="Ejemplo: Botella de agua">
              <b-form-input id="input-1-edit" v-model="productToEdit.name" required placeholder="Ingrese el nombre del producto"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="input-group-2" label="Estado:" label-for="input-2" description="Estado del producto.">
              <b-form-checkbox-group
                id="checkbox-group-2"
                v-model="productToEdit.activeArray"
                :options="options"
                name="flavour-2"
              ></b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </div>
        <div class="row">
          <b-col md="6">
            <b-form-group id="input-group-3" label="Precio:" label-for="input-3" description="Precio del producto.">
              <money v-model="productToEdit.cost" v-bind="money" class="form-control" required></money>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="inventoryCheck">
            <b-form-group id="input-group-4" label="Cantidad:" label-for="input-4" description="Cantidad del producto.">
              <vue-number-input controls style="width: 10rem" v-model="productToEdit.quantity" :min="0"></vue-number-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="input-group-1-edit" label="Código de barras:" label-for="input-code-bar" description="Ejemplo: 8014572365842">
              <div class="d-flex flex-row align-items-center">
                <b-form-input id="input-code-bar" v-model="productToEdit.barCode" placeholder="Ingrese el codigo de barras"></b-form-input>
              <i class="fa fa-info-circle ml-1" v-b-tooltip title="Ingresa un código alfanumérico o numérico con una longitud máxima de 16 caracteres."/>
              </div>
            </b-form-group>
          </b-col>
          <b-col md="12">
              <label for="textarea">Descripción:</label>
              <b-form-textarea
                id="textarea"
                v-model="productToEdit.description"
                placeholder="Descripción"
                rows="3"
                max-rows="6"
                maxlength="255"
              ></b-form-textarea>
              <small :class="{'': characterEnabledEdit > 0, 'text-danger': characterEnabledEdit === 0 }">{{ characterEnabledEdit }} caracteres restantes</small>
          </b-col>
        </div>
        <b-button @click="$bvModal.hide('edit-product')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
        <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
      </b-form>
    </b-modal>
    <b-modal id="upload-image-product" ref="modal-upload-image-product" :title="'Subir imagen del producto ' + this.productToEdit.name" hide-footer>
      <b-row class="justify-content-center">
        <div style="max-width:300px">
          <b-row>
            <img :src="`${filePath}`"
            @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
            width="200" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
          </b-row>
          <b-row>
            <b-form-file
              @change="onFileChange"
              placeholder="Seleccione una imagen"
              drop-placeholder="Suelta la imagen aquí"
              accept="image/jpeg, image/png, image/gif"
              browse-text="Buscar imagen"
              v-model="file"
            ></b-form-file>
          </b-row>
          <p class="text-secondary">La imagen no debe superar las 5MB</p>
          <b-row class="justify-content-center">
            <b-button @click="$bvModal.hide('upload-image-product')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
            <b-button @click="uploadImage()" type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
          </b-row>
        </div>
      </b-row>
    </b-modal>
    <b-modal size="xl" id="add-tags" ref="tags" title="Administrar categorías" hide-footer>
      <b-container>
        <b-row align-h="start">
          <b-col sm="15" lg="auto" xl="6">
            <h5>
              <b-row align-h="center">
                <b-col sm="12" lg="6" class="p-3" style="text-align: center;">
                  <label>{{ productToEdit.name }}</label>
                </b-col>
              </b-row>
            </h5>
            <b-row align-h="center">
              <div style="width:100%">s
                <b-row>
                  <img :src="`${filePath}`"
                  @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                  width="200" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
                </b-row>
                <b-row align-h="center">
                  <b-col sm="12" md="auto" lg="auto" class="p-3">
                    <label>Etiquetas existentes</label>
                  </b-col>
                </b-row>
                <b-row class="justify-content-center">
                  <b-col sm="10" md="10" lg="8" xl="8" align-self="center">
                    <b-row>
                      <b-col>
                        <multiselect class="input1" v-model="listCategories" :options="categories" :multiple="true" :taggable="true" label="name" track-by="id"
                          select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
                          placeholder="Seleccione una opción" style="width: 100%;">
                          <span slot="noOptions">La lista esta vacía.</span>
                        </multiselect>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="justify-content-center">
                  <b-button @click="$bvModal.hide('add-tags')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
                  <b-button @click="saveCategoriesProduct(productToEdit)" type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
                </b-row>
              </div>
            </b-row>
          </b-col>
          <b-col>
            <b-collapse id="taggs-collapse" class="mt-2" v-model="visibleCollapse">
              <b-card>
                <b-form @submit="saveNewCategory" @reset="onReset">
                  <b-form-group id="input-group-1" label="Nombre de la categoría:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="newCategory.name"
                      placeholder="Ingrese el nombre de la categoría"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group id="input-group-2" label="Descripción:" label-for="input-2">
                    <b-form-input
                      id="input-2"
                      v-model="newCategory.description"
                      placeholder="Ingrese la descripción de la categoría"
                    ></b-form-input>
                  </b-form-group>
                  <b-button type="submit" variant="primary">Guardar</b-button>
                  <b-button @click="visibleCollapse = !visibleCollapse" variant="light" class="btn-sm">Cancelar</b-button>
                </b-form>
              </b-card>
            </b-collapse>
            <a-divider orientation="left">Lista de categorías creadas
              <b-button variant="primary" @click="create()" style="position: absolute; right: 2rem; top: -0.5em; z-index: 1;">Crear</b-button>
            </a-divider>
            <b-pagination v-if="categories.length !== 0"
              v-model="page"
              :total-rows="categories.length"
              :per-page="4"
              aria-controls="categoriesTable"
            ></b-pagination>
            <b-table id="categoriesTable" v-if="categories.length !== 0" :per-page="4" :current-page="page" striped hover :fields="tableColumns" :items="categories" head-variant="light" responsive v-show="categories">
              <template #cell(actions)="data">
                <b-link ref="focusme" @click="editCategory(data.item)">Editar</b-link><br>
                <b-link @click="deleteCategory(data.item)">Eliminar</b-link>
              </template>
            </b-table>
            <empty-table v-show="categories.length === 0"/>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal id="see-product" no-enforce-focus ref="modal" title="Producto" hide-footer size="lg">
      <b-row class="m-3">
        <b-col>
          <product :product="productModal"/>
        </b-col>
      </b-row>
      <span class="d-flex flex-row float-right mr-4 mb-3 mt-0 align-text-bottom">
        <b-button @click="$bvModal.hide('see-product')" variant="light" size="sm">Cerrar</b-button>
      </span>
    </b-modal>
  </div>
</template>
<style>
 .input1{
   width: 363px;
 }
 @media screen and (max-width: 920px) {
  .input1 {
    width: 153px;
  }
}
</style>
<script>
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import axios from 'axios'
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import { Money } from 'v-money'
import { consts, showErrorMessage } from '@/services/utilities'
import emptyTable from '@/components/custom/cardEmptyList'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import store from 'store'
import moment from 'moment'
import product from '../../../components/custom/product'
import { ToastFire } from '@/services/utilities/swal'

const columns = [
  { label: 'Código', dataIndex: 'id', key: 'id' },
  { label: 'Nombre', dataIndex: 'name', key: 'name' },
  { label: 'Precio', dataIndex: 'cost', key: 'cost' },
  { label: 'Activo', dataIndex: 'active', key: 'active' },
  { label: 'Acción', dataIndex: '', key: 'action' },
]

export default {
  name: 'ManagementProduct',
  components: { Money, emptyTable, VueNumberInput, product },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$',
        suffix: '',
        precision: 0,
        masked: false, /* doesn't work with directive */
        requerid: true,
      },
      newCategory: {
        id: '',
        name: '',
        description: '',
      },
      tableColumns: [
        { key: 'id', label: 'Código' },
        { key: 'name', label: 'Nombre' },
        { key: 'actions', label: 'Acciones' },
      ],
      form: {
        name: '',
        cost: '',
        barCode: '',
        active: true,
        activeArray: [true],
        description: '',
      },
      options: [
        { text: 'Activo', value: true },
      ],
      productModal: {},
      productToEdit: {
        name: '',
        cost: '',
        active: true,
        barCode: '',
        activeArray: [true],
        quantity: '',
        path: '',
        pathAvatar: '',
        categories: [],
        description: '',
      },
      pagination: {
        rows: 0,
        perPage: 10,
        page: 1,
      },
      visibleCollapse: false,
      file: null,
      filePath: null,
      data: [],
      categories: [],
      listCategories: [],
      columns,
      searchProduct: '',
      accessToken: '',
      endDate: '',
      typingTimer: '',
      iduser: '',
      page: 1,
      inventoryCheck: false,
      inventoryOrderCheck: false,
    }
  },
  computed: {
    ...mapState(['user']),
    characterEnabled() {
      return 255 - this.form.description.length
    },
    characterEnabledEdit() {
      return 255 - this.productToEdit.description.length
    },
  },
  beforeRouteEnter (to, from, next) {
    function getProducts() {
      const sentParams = {
        perPage: 10,
        page: 0,
      }
      return apiClient2.get('/sales/products', { params: sentParams })
    }
    function getCategories() {
      return apiClient.get('/products/categories')
    }

    function getParams() {
      return apiClient2.get('/schoolParam/active')
    }
    axios.all([getProducts(), getCategories(), getParams()])
      .then(axios.spread(function (data, categories, params) {
        next((vm) => {
          vm.setDataProducts(null, data.data)
          vm.setDataCategories(null, categories.data)
          vm.setDataParams(null, params.data.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataProducts(err, [])
          vm.setDataCategories(err, [])
          vm.setDataParams(err, [])
        })
      })
  },
  watch: {
    searchProduct: function() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.search() }, 500)
    },
  },
  methods: {
    async checkValue(product) {
      product.order = parseInt(product.order)
      if (product.order > this.pagination.rows) {
        product.order = this.pagination.rows
      } else if (!product.order || isNaN(product.order)) {
        product.order = 0
      }
      await apiClient.patch(`/products/${product.id}/order`, { order: product.order }).then(response => {
        this.$notification.success({
          message: 'Cambio exitoso',
          description:
            'El orden fue cambiado con éxito',
        })
      })
      await this.search()
    },
    setDataProducts (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.data = data.data.rows.map(item => ({
          ...item,
          description: item.description ?? '',
        }))
        this.pagination.rows = data.data.count
      }
    },
    setDataCategories (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.categories = data
      }
    },
    setDataParams (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        if (data) {
          this.inventoryCheck = false
          for (const combo of data) {
            if (combo.key === consts.params.INVENTORY) {
              this.inventoryCheck = combo.active
              this.columns = [
                { label: 'Código', dataIndex: 'id', key: 'id' },
                { label: 'Nombre', dataIndex: 'name', key: 'name' },
                { label: 'Precio', dataIndex: 'cost', key: 'cost' },
                { label: 'Cantidad', dataIndex: 'quantity', key: 'quantity' },
                { label: 'Activo', dataIndex: 'active', key: 'active' },
                { label: 'Acción', dataIndex: '', key: 'action' },
              ]
            } else if (combo.key === consts.params.ORDER) {
              this.inventoryOrderCheck = combo.active
              this.columns.splice(4, 0, { label: 'Orden', dataIndex: 'order', key: 'order' })
            }
          }
        }
      }
    },
    create() { // Boton crear
      this.newCategory = {
        id: '',
        name: '',
        description: '',
      }
      this.visibleCollapse = !this.visibleCollapse
    },
    async search() {
      const sentParams = {
        perPage: this.pagination.perPage,
        page: this.pagination.page - 1,
        productName: this.searchProduct,
      }
      await apiClient2.get('/sales/products', { params: sentParams }).then(response => {
        this.setDataProducts(null, response.data)
      })
    },
    cleanProductSearch() {
      this.searchProduct = ''
    },
    slugify: function(str) {
      var map = {
        '-': ' ',
        a: 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        e: 'é|è|ê|ë|É|È|Ê|Ë',
        i: 'í|ì|î|ï|Í|Ì|Î|Ï',
        o: 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        c: 'ç|Ç',
      }
      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern)
      }
      return str
    },
    save(evt) { // Guarda un producto llamando a la API
      evt.preventDefault()
      if (this.form.cost <= 0 || this.form.cost % 50 !== 0) {
        this.$notification.warning({
          message: 'Error de validación',
          description: 'El costo del producto debe ser mayor a cero y múltiplo de 50.',
        })
        return
      }
      if (this.form.barCode && this.form.barCode.length > 16) {
        ToastFire('warning', 'El código de barras debe tener una longitud máxima de 16 caracteres.')
        return
      }
      this.form.active = this.form.activeArray.length === 1
      apiClient.post('/products', this.form).then(response => {
        this.data.push(response.data)
        this.form.name = ''
        this.form.cost = ''
        this.form.description = ''
        this.form.barCode = ''
        this.form.active = this.form.activeArray[0]
        this.$notification.success({
          message: 'Creado exitosamente',
          description: `El producto ${response.data.name} fue creado con éxito.`,
        })
      }).catch(err => {
        this.$notification.warning({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    saveNewCategory(evt) { // Guarda un producto llamando a la API
      evt.preventDefault()
      if (!this.newCategory.name) {
        this.$notification.warning({
          message: 'Error de validación',
          description: 'La categoría debe llevar un nombre.',
        })
        return
      }
      if (this.newCategory.id) { // Ya existe el id entonces se edita
        this.saveEditCategory()
      } else {
        apiClient.post('/products/categories', this.newCategory).then(response => {
          this.categories.push(response.data)
          this.newCategory.name = ''
          this.newCategory.description = ''
          Swal.fire('Creado exitosamente', `La categoría ${response.data.name} fue creada con éxito.`, 'success')
          this.visibleCollapse = !this.visibleCollapse
          this.$refs.focusme.focus()
        }).catch(err => {
          Swal.fire('Ooops ocurrio un error', showErrorMessage(err), 'error')
        })
      }
    },
    saveEditCategory() {
      apiClient.patch('/products/categories/' + this.newCategory.id, this.newCategory).then(response => {
        Swal.fire('Editado exitosamente', `La categoría ${response.data.name} fue actualizada con éxito.`, 'success')
        this.visibleCollapse = !this.visibleCollapse
      }).catch(err => {
        Swal.fire('Ooops ocurrio un error', showErrorMessage(err), 'error')
      })
    },
    downloadProductsReport() {
      const endNameReport = moment(this.endDate).format('YYYY-MM-DD')
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      axios({
        url: process.env.VUE_APP_API_URL + '/reports/sales/products',
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_de_productos_${endNameReport}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      })
    },
    deleteCategory(evt) {
      Swal.fire({
        title: 'Confirmar eliminación de categoría',
        text: '¿Desea eliminar la categoría ' + evt.name + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No.',
      }).then((result) => {
        if (result.isConfirmed) {
          // this.eee(sale)
          apiClient.delete('/products/categories/' + evt.id).then(response => {
            Swal.fire('', `Se ha eliminado la categoría ${evt.name} con éxito.`, 'success')
            this.categories = this.categories.filter(item => item.id !== evt.id)
          }).catch(e => {
            Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
          })
        }
      })
    },
    saveCategoriesProduct(evt) {
      evt.categories = this.listCategories
      apiClient.put('/products/categories/' + evt.id, evt.categories).then(response => {
        evt.categories = this.listCategories
        Swal.fire('Categorias guardadas exitosamente', '', 'success')
      }).catch(err => {
        this.$notification.warning({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    remove() { // Elimina un producto - Aun no implementado
      alert('Eliminado :D')
    },
    openProduct(productIn) {
      this.productModal = productIn
      this.$bvModal.show('see-product')
    },
    openModal(productIn) { // Abre el modal para editar el producto
      this.productToEdit = Object.assign({}, productIn)
      this.productToEdit.activeArray = this.productToEdit.active ? [this.productToEdit.active] : []
      this.$bvModal.show('edit-product')
    },
    deleteProduct(productIn) {
      Swal.fire({
        title: 'Confirmar eliminación',
        text: '¿Desea eliminar el producto ' + productIn.name + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          apiClient.delete('/products/' + productIn.id).then(response => {
            Swal.fire('Producto eliminado con éxito', '', 'success')
            this.search()
          }).catch(e => {
            Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
          })
        }
      })
    },
    openModalTags(productIn) { // Abre el modal para editar el producto
      apiClient.get('/products/categories/' + productIn.id).then(response => {
        this.productToEdit.categories = response.data.categories
        this.listCategories = this.productToEdit.categories
      }).catch(err => {
        this.$notification.warning({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
      this.productToEdit = Object.assign({}, productIn)
      this.listCategories = this.productToEdit.categories
      this.filePath = this.productToEdit.pathAvatar + '?tr=w-300'
      this.productToEdit.activeArray = this.productToEdit.active ? [this.productToEdit.active] : []
      this.$bvModal.show('add-tags')
    },
    onFileChange(e) {
      this.filePath = URL.createObjectURL(e.target.files[0])
    },
    openModalUploadImage(productIn) {
      // this.productToEdit = Object.assign({}, productIn)
      this.productToEdit = productIn
      this.filePath = this.productToEdit.pathAvatar + '?tr=w-300'
      this.$bvModal.show('upload-image-product')
    },
    uploadImage() {
      if (this.file) {
        if (this.file.size > 5000000) {
          alert('La imagen tiene ' + (this.file.size / 1000000) + 'MB y no puede superar las 5MB')
          return
        }

        const formData = new FormData()
        formData.append('file', this.file)

        apiClient.post('/products/' + this.productToEdit.id + '/image',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(response => {
          this.productToEdit = response.data
          this.data.forEach(product => {
            if (product.id === this.productToEdit.id) {
              product.pathAvatar = response.data.pathAvatar
            }
          })
          this.$bvModal.hide('upload-image-product')
          this.$notification.success({
            message: 'Cambio guardados',
            description: 'Se actualizó la imagen de perfil exitosamente.',
          })
        }).catch(error => {
          this.$notification.warning({
            message: 'Error subiendo el archivo',
            description: showErrorMessage(error),
          })
        })
      }
    },
    editCategory(categoryToChange) {
      this.newCategory = categoryToChange
      this.visibleCollapse = true
    },
    edit(evt) { // Edita un producto llamando a la API
      evt.preventDefault()
      if (this.productToEdit.cost <= 0 || this.productToEdit.cost % 50 !== 0) {
        this.$notification.warning({
          message: 'Error de validación',
          description: 'El costo del producto debe ser mayor a cero y múltiplo de 50.',
        })
        return
      }
      if (this.productToEdit.barCode && this.productToEdit.barCode.length > 16) {
        ToastFire('warning', 'El código de barras debe tener una longitud máxima de 16 caracteres.')
        return
      }
      this.productToEdit.active = this.productToEdit.activeArray.length === 1
      apiClient2.patch(`/sales/products/${this.productToEdit.id}`, this.productToEdit).then(response => {
        this.data = this.data.map(x => (x.id === response.data.data.id) ? response.data.data : x)
        this.$notification.success({
          message: 'Modificación exitosa',
          description:
            `Se modificó el producto ${response.data.data.name} correctamente.`,
        })
        this.$bvModal.hide('edit-product')
      }).catch(err => {
        this.$notification.warning({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.name = ''
      this.form.description = ''
    },
  },
  created() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    this.endDate = today
    this.iduser = store.get('id')
    this.accessToken = store.get('accessToken')
  },
}
</script>
<style>
#textarea{
  height: calc(1.5em + .75rem + 2px);
}
</style>
